// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-listbox-item, .p-listbox-list, .p-listbox {
    background-color: #f7f0f0 !important;
}
:host ::ng-deep .p-listbox .p-listbox-list {
    padding: 0;
}
:host ::ng-deep .p-listbox-list {
    list-style-type: none;
    margin: 0;
    padding: 0;
}

#btnMultiplePermit {
    position: relative;
    left: 216px;
}

:host ::ng-deep .ui-grid-row
{
    display: flex !important;
}
.clsLstBox {
    margin-top: 0px;
    /* border-right: 1px solid #C8C8C8 !important; */
    /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); */
    padding-left: 0px !important;
    padding-right: 2px;
    background-color: #f2f2f2;
    margin-right: 10px;
}

.categoryList {
    overflow: hidden;
    width: 100%;
    border: none !important;
}

.category-initials{
    height: 45px;
    width: 45px;
    background-color: #ffffff00;
    color: #f6f8f9;
    line-height: 46px;
    display: inline-block;
    margin-right: 1px;
    border-radius: 50%;
    text-align: center;
    font-weight: 100;
    font-family: Segoe UI;
    font-size: 30px;
}

:host ::ng-deep body .p-listbox {
    padding: 0 !important;
    min-width: 12em !important;
    background: #ffffff !important;
}

 .p-listbox:not(.ui-state-disabled) .p-listbox-item:not(.ui-state-highlight):not(.ui-state-disabled):hover {
    color: #333333;
    background-color: #eaeaea;
   
}


:host ::ng-deep .p-listbox .p-listbox-item {
    /* box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px; */
    border: 0px solid rgb(221, 221, 221) !important;
}

/* .permitbox{
    width: 100%;
    height: 507px;
    overflow: auto;
    border: 1px solid rgb(221, 221, 221);
    border-radius: 5px;
    box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px;
    padding: 5px;
    
} */

.categoryImage {
    height: 7vw;
    width: 7vw;
    margin-top: 10px;
    /* border-radius: 50%; */
}

.categoryCaption {
    margin-left: 15px;
    font-size: 16px;
}

.clsLstBoxChildRight {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #CCC;
}

/* Create three equal columns that floats next to each other */

.column {
    float: left;
    width: 95%;
    padding: 4px;
    min-height: 190px;
    margin: 10px;
    background-color: white;
    /* border-radius: 2px; */
    border: 1px solid #c3dce2;
    /* Should be removed. Only for demonstration */
}

/* Clear floats after the columns */

.row:after {
    content: "";
    display: table;
    clear: both;
}

.cardIcon {
    font-size: 40px;
    color: rgb(30, 12, 134);
    position: relative;
    top: 7px;
}

.clsCheck {
    opacity: 1 !important;
}

.clsPermitContainer {
    width: 100%;
    /* height: 400px; */
    overflow: auto;
    overflow-x: hidden;
    /* border: 1px solid #dddddd; */
    border-radius: 5px;
    /* box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.4); */
    padding: 5px;
    background-color: #fff;
    padding: 15px;
    /* cursor: pointer; */
}

.card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
    transition: 0.3s;
    text-align: center;
}

.card:hover {
    box-shadow: 0 8px 16px 0 rgba(156, 113, 113, 0.3);
}

.cardContainer {
    margin-top: 10px;
    padding: 2px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.clsSeletedPermit {
    width: 98%;
}

.permitImage {
    height: 65px;
    width: 65px;
    /* border-radius: 50%; */
}

.clsTick {
    float: left;
    position: relative;
    top: 11px;
    left: -18px;
}

.clsSelectedPermits {
    margin: 5px;
}

.clsHeading {
    font-size: 14px !important;
    font-weight: bold;
}

:host ::ng-deep .p-toast .p-toast-message {
    border-radius: 3px;
    background:  #b7d8b7 !important;
    /* border: 1px solid #165788 !important;
    border-radius: 3px;
    background: #f4f4f4 !important;
    -moz-box-shadow: 3px 3px 12px #165788;
    -webkit-box-shadow: 3px 3px 12px #165788;
    box-shadow: 3px 3px 12px #165788; */
}
:host ::ng-deep .p-toast .p-toast-message-error {
    background-color: #f8b7bd !important;
    border: 0 none;
    color: #212121 !important;

}

:host ::ng-deep .ui-inputtext {
    width: 100% !important;
}

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0px !important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #212121 !important;
    /* margin-top: 10px; */
}

.toast-header {
    background-color: #165788;
    color: #FFF;
    padding: 1px 1px 1px 10px !important;
}

:host ::ng-deep .ui-multiselect {
    min-width: 38% !important;
    max-width: 38% !important;
}

.divRow {
    padding-top: 10px;
    padding-bottom: 10px;
}

.divLabel {
    padding: 5px;
    /* text-align: right; */
}

:host ::ng-deep body .ui-inputtext {
    border: 0px solid #a6a6a6 !important;
}

.card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);
    transition: .3s;
    /* width: 100px; */
    /* top: 20px; */
    /* border-radius: 2px!important; */
    position: relative;
    display: inline-block;
    margin: 10px 15px;
    transition: transform .25s ease
}

.card:hover {
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .4);
    transform: scale(1.02);
    cursor: pointer;
}

.cardHeader {
    height: 100px;
    width: 100px;
    background-image: linear-gradient(dimgrey, grey, #a9a9a9);
    border-radius: 10px 10px 0 0;
    text-align: center;
    vertical-align: center
}

.cardBody {
    padding: 5px;
    background-color: #003658;
    position: absolute;
    color: #fff;
    width: 100px;
    height: -moz-fit-content;
    height: fit-content;
    text-align: center;
    font-size: 19px
}

.cardBody div {
    font-weight: 700
}

.cardIcon {
    font-size: 90px;
    color: #fff;
    position: relative;
    /* top: 65px */
    height: inherit;
    width: inherit;
}

.cardFooter {
    background-color: #165788;
    color: #fff;
    margin-top: 15px;
    height: 195px;
    border-radius: 0 0 10px 10px
}

.cardFooter a {
    color: #fff
}

.bottom-mid {
    position: absolute;
    bottom: -15px;
    left: 25px;
    color: black;
}

.suspend {
    height: 100px !important;
    width: 84px !important;
    margin: 5px !important;
}

.disabledsuspend {
    height: 100px !important;
    width: 84px !important;
    margin: 5px !important;
    color: #C3C3C3;
}

.suspend:hover {
    box-shadow: 0px 8px 16px 0px;
    transform: scale(1.07);
}

.suspension-img {
    height: 50px !important;
    width: 50px !important;
}

.suspensiondd {
    width: 80% !important;
}

/* :host ::ng-deep .ui-multiselect .ui-multiselect-label{
    height: 25px;
} */

/* :host ::ng-deep .p-listbox{
background-color: #fff !important;
} */

.category-name {
    font-size: 1.4em;
}

:host ::ng-deep .p-listbox {
    border: none !important;
    background: transparent !important;
}

:host ::ng-deep .p-listbox .p-listbox-list .p-listbox-item {
    padding: 0 !important;
    background: none !important;
    border: none !important;
    outline: none !important;
    cursor: pointer !important;
}
.p-listbox-list{
    background-color: transparent;
}
.onsite-header {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #333;
    margin: 0 0 6px 0;
}

.onsite-services {
    /* background: transparent;
    background-color: transparent; */
    box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);
    border: 1px solid #c3dce2 !important;
    border-radius: 5px;
    background-color: #fff;
    height: 50px;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 8px;
}
.onsite-services-NoPermit {
    background-color: #fff;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 8px;
    border-radius: 5px;
}
.onsite-services-empty {
    box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);
    border: 1px solid #c3dce2 !important;
    border-radius: 2px;
    background-color: #fff;
    min-height: 90px;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 8px;
}

.os-ok-icon {
    height: 65px;
    min-width: 65px;
    margin: 11px 8px 15px 8px
}

.ok-icon {
    color: rgb(255, 255, 255);
    font-size: 24px;
    font-weight: 400;
    line-height: 60px;
    height: 65px;
    background-color: #CCC;
    border-radius: 50%;
}

.os-name {
    /* margin: 5px 5px 5px 70px; */
    margin:15px 5px 5px 15px;
    text-align: center;
    width: 100%;
    /* padding: 1px; */
    /* width: 100%; */
    /* overflow: hidden; */
    /* margin: 28px 5px 5px 50px;
    padding: 1px;
    width: 100%;
    overflow: hidden; */
}
 
:host ::ng-deep .p-listbox-item{
    padding:0px !important
}

:host ::ng-deep .p-listbox {
    background-color: transparent !important;
    border: none !important;
}

:host ::ng-deep .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover {
    background: none !important;
}
 
:host ::ng-deep .p-listbox-list {
    background-color: transparent !important;
}

.os-name-empty {
    margin: 5px 5px 5px 5px;
    padding: 5px;
    width: 100%;
    overflow: hidden;
    
}

.os-name-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    /* text-align: left; */
    color: rgb(66, 137, 193);
    font-size: 13px;
    font-weight: 600;
    width: 27vw;
    /* color: #4a4a4a; */
    /* font-size: 20px;
    line-height: 30px; */
    /* color: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left; */
}
.os-name-text:hover {
    background:none;
}

.os-name-text-empty {
    color: #165788;
    font-size: 15px;
    line-height: 21px;
    overflow: hidden;
    text-align: center;
    margin-left: 5px;
    font-weight: 400;
    /* color: #165788;
    font-size: 15px;
    line-height: 18px;
    overflow: hidden;
    text-align: center;
    margin-left: 5px;
    font-weight: 400; */
    /* color: #4a4a4a;
    font-size: 20px;
    line-height: 30px;
    overflow: hidden;
    text-align: left;
    margin-left: 5px; */
}

.category-card {
/* padding: 8px;
background: transparent; */
    /* padding: 8px; */
    background: #888;
    padding: 23px;
    margin-right: 20px;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 42px;
    height: 120px;
    border-radius: 5px;
    cursor: pointer;
}
.category-card:hover {
    transform: scale(1.02);
}
.clicked {
    /* position: absolute;
    top: 0;
    left: 0;
    background-image: url('../../assets/Images/green-tick.svg');
    background-repeat: no-repeat;
    background-size: 10px; */
    box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);
} 

.category-image {
    /* height: 200px;
    width: 200px; */
    /* width: 100%;
    height: 30vh;
    cursor: pointer; */
    width: 50px;
    height: 50px;
    cursor: pointer;
    /* border-radius: 40px; */
}

.circle-image {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    margin:auto;
    display: inline-block;
    padding: 13px 12px 15px 12px;
}

.category-image:hover {
    transform: scale(1.03);
}
.background-body{
    background-color: #f2f2f2;
    padding: 0px !important;
    position: relative !important;
    margin: 0 !important;
}
.clsleft{
    /* background-color: #fff; */
    background-image: url('select-category-overlay-bg.87c04b3db21c4a4e.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: bottom;
    background-repeat: no-repeat;
    /* opacity: 0.7; */
}

.clsright{
    background-color: transparent !important;
    border: 0.1px solid #d4d4d457;

}
.clsright .clsPermitContainer{
    background-color:transparent !important;
}
.CategoryName{
  position: relative;
  top: 28px;
  font-weight: 600;
}

@media screen and (min-width: 40.063em){
.md:col-6 {
    width: 100% !important;
}
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape){
    .p-listbox-item, .p-listbox-list, .p-listbox {
        background-color: #f7f0f0 !important;
    }
    .navbar-form .form-group {
        width: 100% !important;
    }
    #btnMultiplePermit {
        position: relative;
        left: 216px;
    }
    
    .clsLstBox {
        margin-top: 0px;
        /* border-right: 1px solid #C8C8C8 !important; */
        /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); */
        padding-left: 0px !important;
        padding-right: 2px;
        background-color: #f2f2f2;
    }
    
    .categoryList {
        overflow: hidden;
        width: 100%;
        border: none !important;
    }
    
    :host ::ng-deep body .p-listbox {
        padding: 0 !important;
        min-width: 12em !important;
        background: #ffffff !important;
    }
    
    :host ::ng-deep .p-listbox .p-listbox-item {
        /* box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px; */
        border: 0px solid rgb(221, 221, 221) !important;
    }
    
   
    
    .categoryImage {
        height: 7vw;
        width: 7vw;
        margin-top: 10px;
        /* border-radius: 50%; */
    }
    
    .categoryCaption {
        margin-left: 15px;
        font-size: 16px;
    }
    
    .clsLstBoxChildRight {
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #CCC;
    }
    
    /* Create three equal columns that floats next to each other */
    
    .column {
        float: left;
        width: 95%;
        padding: 4px;
        min-height: 190px;
        margin: 10px;
        background-color: white;
        /* border-radius: 2px; */
        border: 1px solid #c3dce2;
        /* Should be removed. Only for demonstration */
    }
    
    /* Clear floats after the columns */
    
    .row:after {
        content: "";
        display: table;
        clear: both;
    }
    
    .cardIcon {
        font-size: 40px;
        color: rgb(30, 12, 134);
        position: relative;
        top: 7px;
    }
    
    .clsCheck {
        opacity: 1 !important;
    }
    
    .clsPermitContainer {
        width: 100%;
        /* height: 400px; */
        overflow: auto;
        overflow-x: hidden;
        /* border: 1px solid #dddddd; */
        border-radius: 5px;
        /* box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.4); */
        padding: 5px;
        background-color: #fff;
        padding: 15px;
        /* cursor: pointer; */
    }
    
    .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
        transition: 0.3s;
        text-align: center;
    }
    
    .card:hover {
        box-shadow: 0 8px 16px 0 rgba(156, 113, 113, 0.3);
    }
    
    .cardContainer {
        margin-top: 10px;
        padding: 2px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .clsSeletedPermit {
        width: 98%;
    }
    
    .permitImage {
        height: 65px;
        width: 65px;
        /* border-radius: 50%; */
    }
    
    .clsTick {
        float: left;
        position: relative;
        top: 11px;
        left: -18px;
    }
    
    .clsSelectedPermits {
        margin: 5px;
    }
    
    .clsHeading {
        font-size: 14px !important;
        font-weight: bold;
    }
    
    :host ::ng-deep .p-toast .p-toast-message {
        border: 1px solid #165788 !important;
        border-radius: 3px;
        background: #f4f4f4 !important;
        box-shadow: 3px 3px 12px #165788;
    }
    
    :host ::ng-deep .ui-inputtext {
        width: 100% !important;
    }
    
    :host ::ng-deep .p-toast .p-toast-message-content {
        padding: 0px !important;
    }
    
    :host ::ng-deep .p-toast .p-toast-close-icon {
        color: #ffffff !important;
        /* margin-top: 10px; */
    }
    
    .toast-header {
        background-color: #165788;
        color: #FFF;
        padding: 1px 1px 1px 10px !important;
    }
    
    :host ::ng-deep .ui-multiselect {
        min-width: 38% !important;
        max-width: 38% !important;
    }
    
    .divRow {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    
    .divLabel {
        padding: 5px;
        /* text-align: right; */
    }
    
    :host ::ng-deep body .ui-inputtext {
        border: 0px solid #a6a6a6 !important;
    }
    
    .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);
        transition: .3s;
        /* width: 100px; */
        /* top: 20px; */
        /* border-radius: 2px!important; */
        position: relative;
        display: inline-block;
        margin: 10px 15px;
        transition: transform .25s ease
    }
    
    .card:hover {
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .4);
        transform: scale(1.02);
        cursor: pointer;
    }
    
    .cardHeader {
        height: 100px;
        width: 100px;
        background-image: linear-gradient(dimgrey, grey, #a9a9a9);
        border-radius: 10px 10px 0 0;
        text-align: center;
        vertical-align: center
    }
    
    .cardBody {
        padding: 5px;
        background-color: #003658;
        position: absolute;
        color: #fff;
        width: 100px;
        height: -moz-fit-content;
        height: fit-content;
        text-align: center;
        font-size: 19px
    }
    
    .cardBody div {
        font-weight: 700
    }
    
    .cardIcon {
        font-size: 90px;
        color: #fff;
        position: relative;
        /* top: 65px */
        height: inherit;
        width: inherit;
    }
    
    .cardFooter {
        background-color: #165788;
        color: #fff;
        margin-top: 15px;
        height: 195px;
        border-radius: 0 0 10px 10px
    }
    
    .cardFooter a {
        color: #fff
    }
    
    .bottom-mid {
        position: absolute;
        bottom: -15px;
        left: 25px;
        color: black;
    }
    
    .suspend {
        height: 100px !important;
        width: 84px !important;
        margin: 5px !important;
    }
    
    .disabledsuspend {
        height: 100px !important;
        width: 84px !important;
        margin: 5px !important;
        color: #C3C3C3;
    }
    
    .suspend:hover {
        box-shadow: 0px 8px 16px 0px;
        transform: scale(1.07);
    }
    
    .suspension-img {
        height: 50px !important;
        width: 50px !important;
    }
    
    .suspensiondd {
        width: 80% !important;
    }
    
    /* :host ::ng-deep .ui-multiselect .ui-multiselect-label{
        height: 25px;
    } */
    
    /* :host ::ng-deep .p-listbox{
    background-color: #fff !important;
    } */
    
    .category-name {
        font-size: 1.4em;
    }
    
    :host ::ng-deep .p-listbox {
        border: none !important;
    }
    
    :host ::ng-deep .p-listbox .p-listbox-list .p-listbox-item {
        padding: 0 !important;
    }
    
    .onsite-header {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
        margin: 0 0 6px 0;
    }
    
    .onsite-services {
   
        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);
        border: 1px solid #c3dce2 !important;
        border-radius: 5px;
        background-color: #fff;
        min-height: 50px;
        box-sizing: border-box;
        display: flex;
        margin-bottom: 8px;
    }
    
    .onsite-services-NoPermit {
        background-color: #fff;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        margin-bottom: 8px;
    }
    .onsite-services-empty {
        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);
        border: 1px solid #c3dce2 !important;
        border-radius: 2px;
        background-color: #fff;
        min-height: 90px;
        box-sizing: border-box;
        display: flex;
        margin-bottom: 8px;
    }
    
    .os-ok-icon {
        height: 65px;
        min-width: 65px;
        margin: 11px 8px 15px 8px
    }
    
    .ok-icon {
        color: rgb(255, 255, 255);
        font-size: 24px;
        font-weight: 400;
        line-height: 60px;
        height: 65px;
        background-color: #CCC;
        border-radius: 50%;
    }
    
    .os-name {
        margin: 12px 14px 5px 12px;
        padding: 5px;
        width: 100%;
        overflow: hidden;
        text-align: center;
        /* margin: 28px 5px 5px 50px;
        padding: 1px;
        width: 100%;
        overflow: hidden; */
    }
    
    .os-name-empty {
        margin: 8px 5px 5px 5px;
        padding: 1px;
        width: 100%;
        overflow: hidden;
    }
    
    .os-name-text {
        color: rgb(66, 137, 193);
        font-size: 15px;
        line-height: 15px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        /* text-align: left; */
        font-weight: 600;
        /* color: #4a4a4a;
        font-size: 20px;
        line-height: 30px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left; */
    }
    
    .os-name-text-empty {
        color: #165788;
    font-size: 12px;
    line-height: 17px;
    overflow: hidden;
    text-align: center;
        /* color: #4a4a4a;
        font-size: 20px;
        line-height: 30px;
        overflow: hidden;
        text-align: left;
        margin-left: 5px; */
    }
    
    .category-card {
        padding: 8px;
        background: transparent;
        cursor: pointer;
    }
    .category-card:hover {
        transform: scale(1.02);
    }
    .clicked {
        /* position: absolute;
        top: 0;
        left: 0;
        background-image: url('../../assets/Images/green-tick.svg');
        background-repeat: no-repeat;
        background-size: 10px; */
        box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);
    }    

    .circle-image {
        width: 62px;
        height: 62px;
        border-radius: 50%;
        margin: auto;
        display: inline-block;
        padding: 12px 10px;
        position: relative;
        top: 17px;
    }
    
    .category-image {
        height: 40px;
        width: 40px;
        cursor: pointer;
        top:0px;   
        position: relative;
              /* border-radius: 30px; */
        /* top: 24px; */
        /* height: 100%;
        width: 100%;
        cursor: pointer; */
    }
    
    .category-image:hover {
        transform: scale(1.03);
    }
    .background-body{
        background-color: #f2f2f2;
        padding: 0px !important;
        position: relative !important;
        margin: 0 !important;
    }
    .CategoryName{
        position: relative;
        top: 58px;
        font-size: 12px;
        font-weight: 600;
      }
}


@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait){
    .p-listbox-item, .p-listbox-list, .p-listbox {
        background-color: #f7f0f0 !important;
    }
    .CategoryName{
        position: relative;
        top: 58px;
        font-size: 10px;
        width: 100px;
        left: -42px;
        font-weight: 600;
      }
    /* Override start */
    .navbar .navbar-header {
        margin-left: 10%!important;
        /* margin-right: 0!important; */
    }
    .app-name {
        color: white;
        margin-left: 8px;
        /* font-size: 28px; */
        /* font-weight: bold; */
        vertical-align: -8px;
        text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);
        font-family: Segoe UI;
        font-weight: 100;
    }
    /* Override end */
    #btnMultiplePermit {
        position: relative;
        left: 216px;
    }
    
    .clsLstBox {
        margin-top: 0px;
        /* border-right: 1px solid #C8C8C8 !important; */
        /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); */
        padding-left: 0px !important;
        padding-right: 2px;
        background-color: #f2f2f2;
    }
    
    .categoryList {
        overflow: hidden;
        width: 100%;
        border: none !important;
    }
    
    :host ::ng-deep body .p-listbox {
        padding: 0 !important;
        min-width: 12em !important;
        background: #ffffff !important;
    }
    
    :host ::ng-deep .p-listbox .p-listbox-item {
        /* box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px; */
        border: 0px solid rgb(221, 221, 221) !important;
    }
    
  
    
    .categoryImage {
        height: 7vw;
        width: 7vw;
        margin-top: 10px;
        /* border-radius: 50%; */
    }
    
    .categoryCaption {
        margin-left: 15px;
        font-size: 16px;
    }
    
    .clsLstBoxChildRight {
        padding: 10px;
        border-radius: 5px;
        border: 1px solid #CCC;
    }
    
    /* Create three equal columns that floats next to each other */
    
    .column {
        float: left;
        width: 95%;
        padding: 4px;
        min-height: 190px;
        margin: 10px;
        background-color: white;
        /* border-radius: 2px; */
        border: 1px solid #c3dce2;
        /* Should be removed. Only for demonstration */
    }
    
    /* Clear floats after the columns */
    
    .row:after {
        content: "";
        display: table;
        clear: both;
    }
    
    .cardIcon {
        font-size: 40px;
        color: rgb(30, 12, 134);
        position: relative;
        top: 7px;
    }
    
    .clsCheck {
        opacity: 1 !important;
    }
    
    .clsPermitContainer {
        width: 100%;
        /* height: 400px; */
        overflow: auto;
        overflow-x: hidden;
        /* border: 1px solid #dddddd; */
        border-radius: 5px;
        /* box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.4); */
        padding: 5px;
        background-color: #fff;
        padding: 15px;
        /* cursor: pointer; */
    }
    
    .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
        transition: 0.3s;
        text-align: center;
    }
    
    .card:hover {
        box-shadow: 0 8px 16px 0 rgba(156, 113, 113, 0.3);
    }
    
    .cardContainer {
        margin-top: 10px;
        padding: 2px;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    
    .clsSeletedPermit {
        width: 98%;
    }
    
    .permitImage {
        height: 65px;
        width: 65px;
        /* border-radius: 50%; */
    }
    
    .clsTick {
        float: left;
        position: relative;
        top: 11px;
        left: -18px;
    }
    
    .clsSelectedPermits {
        margin: 5px;
    }
    
    .clsHeading {
        font-size: 14px !important;
        font-weight: bold;
    }
    
    :host ::ng-deep .p-toast .p-toast-message {
        border: 1px solid #165788 !important;
        border-radius: 3px;
        background: #f4f4f4 !important;
        box-shadow: 3px 3px 12px #165788;
    }
    
    :host ::ng-deep .ui-inputtext {
        width: 100% !important;
    }
    
    :host ::ng-deep .p-toast .p-toast-message-content {
        padding: 0px !important;
    }
    
    :host ::ng-deep .p-toast .p-toast-close-icon {
        color: #ffffff !important;
        /* margin-top: 10px; */
    }
    
    .toast-header {
        background-color: #165788;
        color: #FFF;
        padding: 1px 1px 1px 10px !important;
    }
    
    :host ::ng-deep .ui-multiselect {
        min-width: 38% !important;
        max-width: 38% !important;
    }
    
    .divRow {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    
    .divLabel {
        padding: 5px;
        /* text-align: right; */
    }
    
    :host ::ng-deep body .ui-inputtext {
        border: 0px solid #a6a6a6 !important;
    }
    
    .card {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);
        transition: .3s;
        /* width: 100px; */
        /* top: 20px; */
        /* border-radius: 2px!important; */
        position: relative;
        display: inline-block;
        margin: 10px 15px;
        transition: transform .25s ease
    }
    
    .card:hover {
        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .4);
        transform: scale(1.02);
        cursor: pointer;
    }
    
    .cardHeader {
        height: 100px;
        width: 100px;
        background-image: linear-gradient(dimgrey, grey, #a9a9a9);
        border-radius: 10px 10px 0 0;
        text-align: center;
        vertical-align: center
    }
    
    .cardBody {
        padding: 5px;
        background-color: #003658;
        position: absolute;
        color: #fff;
        width: 100px;
        height: -moz-fit-content;
        height: fit-content;
        text-align: center;
        font-size: 19px
    }
    
    .cardBody div {
        font-weight: 700
    }
    
    .cardIcon {
        font-size: 90px;
        color: #fff;
        position: relative;
        /* top: 65px */
        height: inherit;
        width: inherit;
    }
    
    .cardFooter {
        background-color: #165788;
        color: #fff;
        margin-top: 15px;
        height: 195px;
        border-radius: 0 0 10px 10px
    }
    
    .cardFooter a {
        color: #fff
    }
    
    .bottom-mid {
        position: absolute;
        bottom: -15px;
        left: 25px;
        color: black;
    }
    
    .suspend {
        height: 100px !important;
        width: 84px !important;
        margin: 5px !important;
    }
    
    .disabledsuspend {
        height: 100px !important;
        width: 84px !important;
        margin: 5px !important;
        color: #C3C3C3;
    }
    
    .suspend:hover {
        box-shadow: 0px 8px 16px 0px;
        transform: scale(1.07);
    }
    
    .suspension-img {
        height: 50px !important;
        width: 50px !important;
    }
    
    .suspensiondd {
        width: 80% !important;
    }
    
    /* :host ::ng-deep .ui-multiselect .ui-multiselect-label{
        height: 25px;
    } */
    
    /* :host ::ng-deep .p-listbox{
    background-color: #fff !important;
    } */
    
    .category-name {
        font-size: 1.4em;
    }
    
    :host ::ng-deep .p-listbox {
        border: none !important;
    }
    
    :host ::ng-deep .p-listbox .p-listbox-list .p-listbox-item {
        padding: 0 !important;
    }
    
    .onsite-header {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #333;
        margin: 0 0 6px 0;
    }
    
    .onsite-services {
        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);
        border: 1px solid #c3dce2 !important;
        border-radius: 5px;
        background-color: #fff;
        min-height: 40px;
        box-sizing: border-box;
        display: flex;
        margin-bottom: 8px;
    }
    .onsite-services-NoPermit {
        background-color: #fff;
        height: 100%;
        box-sizing: border-box;
        display: flex;
        margin-bottom: 8px;
    }
    .onsite-services-empty {
        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);
        border: 1px solid #c3dce2 !important;
        border-radius: 2px;
        background-color: #fff;
        min-height: 90px;
        box-sizing: border-box;
        display: flex;
        margin-bottom: 8px;
    }
    
    .os-ok-icon {
        height: 65px;
        min-width: 65px;
        margin: 11px 8px 15px 8px
    }
    
    .ok-icon {
        color: rgb(255, 255, 255);
        font-size: 24px;
        font-weight: 400;
        line-height: 60px;
        height: 65px;
        background-color: #CCC;
        border-radius: 50%;
    }
    
    .os-name {
        /* margin: 28px 5px 5px 6px; */
      margin:15px 5px 5px 15px;
      padding: 5px;
      width: 100%;
      overflow: hidden;
      text-align: center;
    }
    
    .os-name-empty {
        margin: 14px 5px 5px 5px;
        padding: 1px;
        width: 100%;
        overflow: hidden;
    }
    
    .os-name-text {
        color: black;
        font-size: 11px;
        line-height: 13px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        /* text-align: left; */
        font-weight: 600;
        /* color: #4a4a4a;
        font-size: 20px;
        line-height: 30px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: left; */
    }
    
    .os-name-text-empty {
        color: #165788;
        font-size: 12px;
        line-height: 17px;
        overflow: hidden;
        text-align: left;
        /* color: #4a4a4a;
        font-size: 20px;
        line-height: 30px;
        overflow: hidden;
        text-align: left;
        margin-left: 5px; */
    }
    
    .category-card {
        padding-top: 4px;
        padding: -52px;
        margin-right: 20px;
        margin-left: 20px;
        margin-top: 10px;
        margin-bottom: 42px;
        height: 120px;
        border-radius: 5px;
        padding-left: 39px;
        padding-right: 50px;
        padding-bottom: 7px;
        cursor: pointer;
        /* padding: 8px;
        background: transparent; */
    }
    .category-card:hover {
        transform: scale(1.02);
    }
    .clicked {
        /* position: absolute;
        top: 0;
        left: 0;
        background-image: url('../../assets/Images/green-tick.svg');
        background-repeat: no-repeat;
        background-size: 10px; */
        box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);
    } 

    .circle-image {
        width: 62px;
        height: 62px;
        border-radius: 50%;
        margin: auto;
        display: inline-block;
        padding: 12px 10px;
        position: relative;
        left: -24px;
        top: 17px;
    }
    
    .category-image {
        height: 37px;
        width: 37px;
        cursor: pointer;
        position: relative;
        top: 0px;
        left: 1px;
        /* height: 50px;
        width: 50px;
        cursor: pointer;
        position: relative;
        top: 19px; */
        /* height: 100%;
        width: 100%;
        cursor: pointer; */
    }
    
    .category-image:hover {
        transform: scale(1.1);
    }
    .background-body{
        background-color: #f2f2f2;
        padding: 0px !important;
        position: relative !important;
        margin: 0 !important;
    }    
}`, "",{"version":3,"sources":["webpack://./src/app/create-permit/create-permit.component.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;IACI,UAAU;AACd;AACA;IACI,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gDAAgD;IAChD,4CAA4C;IAC5C,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,8BAA8B;AAClC;;CAEC;IACG,cAAc;IACd,yBAAyB;;AAE7B;;;AAGA;IACI,iDAAiD;IACjD,+CAA+C;AACnD;;AAEA;;;;;;;;;GASG;;AAEH;IACI,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,8DAA8D;;AAE9D;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA,mCAAmC;;AAEnC;IACI,WAAW;IACX,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,gDAAgD;IAChD,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B;;;;;uCAKmC;AACvC;AACA;IACI,oCAAoC;IACpC,cAAc;IACd,yBAAyB;;AAE7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yDAAyD;IACzD,4BAA4B;IAC5B,kBAAkB;IAClB;AACJ;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,wBAAmB;IAAnB,mBAAmB;IACnB,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;AAC9B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;oCACgC;IAChC,4CAA4C;IAC5C,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,4CAA4C;IAC5C,oCAAoC;IACpC,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf;AACJ;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB;;;uBAGmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,wCAAwC;IACxC,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,oBAAoB;IACpB;wBACoB;IACpB;;;;uBAImB;AACvB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB;;;;;;uBAMmB;IACnB;;;;;uBAKmB;AACvB;;AAEA;AACA;0BAC0B;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI;;;;;4BAKwB;IAGxB,6CAA6C;AACjD;;AAEA;IACI;mBACe;IACf;;sBAEkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,6BAA6B;IAC7B,oBAAoB;AACxB;AACA;IACI,4BAA4B;IAC5B,wEAA2E;IAC3E,4BAA4B;IAC5B,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,wCAAwC;IACxC,6BAA6B;;AAEjC;AACA;IACI,uCAAuC;AAC3C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;AACA;IACI,sBAAsB;AAC1B;AACA;;AAEA;IACI;QACI,oCAAoC;IACxC;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gDAAgD;QAChD,4CAA4C;QAC5C,4BAA4B;QAC5B,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;QACrB,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,iDAAiD;QACjD,+CAA+C;IACnD;;;;IAIA;QACI,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA,8DAA8D;;IAE9D;QACI,WAAW;QACX,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,YAAY;QACZ,uBAAuB;QACvB,wBAAwB;QACxB,yBAAyB;QACzB,8CAA8C;IAClD;;IAEA,mCAAmC;;IAEnC;QACI,WAAW;QACX,cAAc;QACd,WAAW;IACf;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,+BAA+B;QAC/B,kBAAkB;QAClB,gDAAgD;QAChD,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,0CAA0C;QAC1C,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,oCAAoC;QACpC,kBAAkB;QAClB,8BAA8B;QAG9B,gCAAgC;IACpC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,oCAAoC;IACxC;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,yCAAyC;QACzC,eAAe;QACf,kBAAkB;QAClB,eAAe;QACf,kCAAkC;QAClC,kBAAkB;QAClB,qBAAqB;QACrB,iBAAiB;QACjB;IACJ;;IAEA;QACI,0CAA0C;QAC1C,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,yDAAyD;QACzD,4BAA4B;QAC5B,kBAAkB;QAClB;IACJ;;IAEA;QACI,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,wBAAmB;QAAnB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,4BAA4B;QAC5B,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;OAEG;;IAEH;;OAEG;;IAEH;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf,WAAW;QACX,iBAAiB;IACrB;;IAEA;;QAEI,4CAA4C;QAC5C,oCAAoC;QACpC,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,4CAA4C;QAC5C,oCAAoC;QACpC,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB;;;2BAGmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;QACxB,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB;;;;;;2BAMmB;IACvB;;IAEA;QACI,cAAc;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;QACd;;;;;2BAKmB;IACvB;;IAEA;QACI,YAAY;QACZ,uBAAuB;QACvB,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI;;;;;gCAKwB;QAGxB,6CAA6C;IACjD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;QAClB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,OAAO;QACP,kBAAkB;cACZ,yBAAyB;QAC/B,eAAe;QACf;;0BAEkB;IACtB;;IAEA;QACI,sBAAsB;IAC1B;IACA;QACI,yBAAyB;QACzB,uBAAuB;QACvB,6BAA6B;QAC7B,oBAAoB;IACxB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,gBAAgB;MAClB;AACN;;;AAGA;IACI;QACI,oCAAoC;IACxC;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,eAAe;QACf,YAAY;QACZ,WAAW;QACX,gBAAgB;MAClB;IACF,mBAAmB;IACnB;QACI,0BAA0B;QAC1B,+BAA+B;IACnC;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,qBAAqB;QACrB,uBAAuB;QACvB,oBAAoB;QACpB,+CAA+C;QAC/C,qBAAqB;QACrB,gBAAgB;IACpB;IACA,iBAAiB;IACjB;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,gDAAgD;QAChD,4CAA4C;QAC5C,4BAA4B;QAC5B,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;QACrB,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,iDAAiD;QACjD,+CAA+C;IACnD;;;;IAIA;QACI,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,wBAAwB;IAC5B;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA,8DAA8D;;IAE9D;QACI,WAAW;QACX,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,YAAY;QACZ,uBAAuB;QACvB,wBAAwB;QACxB,yBAAyB;QACzB,8CAA8C;IAClD;;IAEA,mCAAmC;;IAEnC;QACI,WAAW;QACX,cAAc;QACd,WAAW;IACf;;IAEA;QACI,eAAe;QACf,uBAAuB;QACvB,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,+BAA+B;QAC/B,kBAAkB;QAClB,gDAAgD;QAChD,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,qBAAqB;IACzB;;IAEA;QACI,0CAA0C;QAC1C,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,iDAAiD;IACrD;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,oCAAoC;QACpC,kBAAkB;QAClB,8BAA8B;QAG9B,gCAAgC;IACpC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;QACzB,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,oCAAoC;IACxC;;IAEA;QACI,yBAAyB;QACzB,yBAAyB;IAC7B;;IAEA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,yCAAyC;QACzC,eAAe;QACf,kBAAkB;QAClB,eAAe;QACf,kCAAkC;QAClC,kBAAkB;QAClB,qBAAqB;QACrB,iBAAiB;QACjB;IACJ;;IAEA;QACI,0CAA0C;QAC1C,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,YAAY;QACZ,yDAAyD;QACzD,4BAA4B;QAC5B,kBAAkB;QAClB;IACJ;;IAEA;QACI,YAAY;QACZ,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,wBAAmB;QAAnB,mBAAmB;QACnB,kBAAkB;QAClB;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;QACf,WAAW;QACX,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,yBAAyB;QACzB,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,UAAU;QACV,YAAY;IAChB;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;QACtB,sBAAsB;QACtB,cAAc;IAClB;;IAEA;QACI,4BAA4B;QAC5B,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;;OAEG;;IAEH;;OAEG;;IAEH;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,eAAe;QACf,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,4CAA4C;QAC5C,oCAAoC;QACpC,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,sBAAsB;QACtB,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;IACA;QACI,4CAA4C;QAC5C,oCAAoC;QACpC,kBAAkB;QAClB,sBAAsB;QACtB,gBAAgB;QAChB,sBAAsB;QACtB,aAAa;QACb,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf;IACJ;;IAEA;QACI,yBAAyB;QACzB,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,YAAY;QACZ,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;MAChC,wBAAwB;MACxB,YAAY;MACZ,WAAW;MACX,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;QACI,wBAAwB;QACxB,YAAY;QACZ,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,mBAAmB;QACnB,uBAAuB;QACvB,gBAAgB;QAChB,sBAAsB;QACtB,gBAAgB;QAChB;;;;;;2BAMmB;IACvB;;IAEA;QACI,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;QAChB;;;;;2BAKmB;IACvB;;IAEA;QACI,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,kBAAkB;QAClB,kBAAkB;QAClB,mBAAmB;QACnB,mBAAmB;QACnB,eAAe;QACf;kCAC0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI;;;;;gCAKwB;QAGxB,6CAA6C;IACjD;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;QAClB,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT;;;;oBAIY;QACZ;;0BAEkB;IACtB;;IAEA;QACI,qBAAqB;IACzB;IACA;QACI,yBAAyB;QACzB,uBAAuB;QACvB,6BAA6B;QAC7B,oBAAoB;IACxB;AACJ","sourcesContent":[".p-listbox-item, .p-listbox-list, .p-listbox {\r\n    background-color: #f7f0f0 !important;\r\n}\r\n:host ::ng-deep .p-listbox .p-listbox-list {\r\n    padding: 0;\r\n}\r\n:host ::ng-deep .p-listbox-list {\r\n    list-style-type: none;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n#btnMultiplePermit {\r\n    position: relative;\r\n    left: 216px;\r\n}\r\n\r\n:host ::ng-deep .ui-grid-row\r\n{\r\n    display: flex !important;\r\n}\r\n.clsLstBox {\r\n    margin-top: 0px;\r\n    /* border-right: 1px solid #C8C8C8 !important; */\r\n    /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); */\r\n    padding-left: 0px !important;\r\n    padding-right: 2px;\r\n    background-color: #f2f2f2;\r\n    margin-right: 10px;\r\n}\r\n\r\n.categoryList {\r\n    overflow: hidden;\r\n    width: 100%;\r\n    border: none !important;\r\n}\r\n\r\n.category-initials{\r\n    height: 45px;\r\n    width: 45px;\r\n    background-color: #ffffff00;\r\n    color: #f6f8f9;\r\n    line-height: 46px;\r\n    display: inline-block;\r\n    margin-right: 1px;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n    font-weight: 100;\r\n    font-family: Segoe UI;\r\n    font-size: 30px;\r\n}\r\n\r\n:host ::ng-deep body .p-listbox {\r\n    padding: 0 !important;\r\n    min-width: 12em !important;\r\n    background: #ffffff !important;\r\n}\r\n\r\n .p-listbox:not(.ui-state-disabled) .p-listbox-item:not(.ui-state-highlight):not(.ui-state-disabled):hover {\r\n    color: #333333;\r\n    background-color: #eaeaea;\r\n   \r\n}\r\n\r\n\r\n:host ::ng-deep .p-listbox .p-listbox-item {\r\n    /* box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px; */\r\n    border: 0px solid rgb(221, 221, 221) !important;\r\n}\r\n\r\n/* .permitbox{\r\n    width: 100%;\r\n    height: 507px;\r\n    overflow: auto;\r\n    border: 1px solid rgb(221, 221, 221);\r\n    border-radius: 5px;\r\n    box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px;\r\n    padding: 5px;\r\n    \r\n} */\r\n\r\n.categoryImage {\r\n    height: 7vw;\r\n    width: 7vw;\r\n    margin-top: 10px;\r\n    /* border-radius: 50%; */\r\n}\r\n\r\n.categoryCaption {\r\n    margin-left: 15px;\r\n    font-size: 16px;\r\n}\r\n\r\n.clsLstBoxChildRight {\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    border: 1px solid #CCC;\r\n}\r\n\r\n/* Create three equal columns that floats next to each other */\r\n\r\n.column {\r\n    float: left;\r\n    width: 95%;\r\n    padding: 4px;\r\n    min-height: 190px;\r\n    margin: 10px;\r\n    background-color: white;\r\n    /* border-radius: 2px; */\r\n    border: 1px solid #c3dce2;\r\n    /* Should be removed. Only for demonstration */\r\n}\r\n\r\n/* Clear floats after the columns */\r\n\r\n.row:after {\r\n    content: \"\";\r\n    display: table;\r\n    clear: both;\r\n}\r\n\r\n.cardIcon {\r\n    font-size: 40px;\r\n    color: rgb(30, 12, 134);\r\n    position: relative;\r\n    top: 7px;\r\n}\r\n\r\n.clsCheck {\r\n    opacity: 1 !important;\r\n}\r\n\r\n.clsPermitContainer {\r\n    width: 100%;\r\n    /* height: 400px; */\r\n    overflow: auto;\r\n    overflow-x: hidden;\r\n    /* border: 1px solid #dddddd; */\r\n    border-radius: 5px;\r\n    /* box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.4); */\r\n    padding: 5px;\r\n    background-color: #fff;\r\n    padding: 15px;\r\n    /* cursor: pointer; */\r\n}\r\n\r\n.card {\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);\r\n    transition: 0.3s;\r\n    text-align: center;\r\n}\r\n\r\n.card:hover {\r\n    box-shadow: 0 8px 16px 0 rgba(156, 113, 113, 0.3);\r\n}\r\n\r\n.cardContainer {\r\n    margin-top: 10px;\r\n    padding: 2px;\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.clsSeletedPermit {\r\n    width: 98%;\r\n}\r\n\r\n.permitImage {\r\n    height: 65px;\r\n    width: 65px;\r\n    /* border-radius: 50%; */\r\n}\r\n\r\n.clsTick {\r\n    float: left;\r\n    position: relative;\r\n    top: 11px;\r\n    left: -18px;\r\n}\r\n\r\n.clsSelectedPermits {\r\n    margin: 5px;\r\n}\r\n\r\n.clsHeading {\r\n    font-size: 14px !important;\r\n    font-weight: bold;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message {\r\n    border-radius: 3px;\r\n    background:  #b7d8b7 !important;\r\n    /* border: 1px solid #165788 !important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4 !important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788; */\r\n}\r\n:host ::ng-deep .p-toast .p-toast-message-error {\r\n    background-color: #f8b7bd !important;\r\n    border: 0 none;\r\n    color: #212121 !important;\r\n\r\n}\r\n\r\n:host ::ng-deep .ui-inputtext {\r\n    width: 100% !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0px !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #212121 !important;\r\n    /* margin-top: 10px; */\r\n}\r\n\r\n.toast-header {\r\n    background-color: #165788;\r\n    color: #FFF;\r\n    padding: 1px 1px 1px 10px !important;\r\n}\r\n\r\n:host ::ng-deep .ui-multiselect {\r\n    min-width: 38% !important;\r\n    max-width: 38% !important;\r\n}\r\n\r\n.divRow {\r\n    padding-top: 10px;\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.divLabel {\r\n    padding: 5px;\r\n    /* text-align: right; */\r\n}\r\n\r\n:host ::ng-deep body .ui-inputtext {\r\n    border: 0px solid #a6a6a6 !important;\r\n}\r\n\r\n.card {\r\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);\r\n    transition: .3s;\r\n    /* width: 100px; */\r\n    /* top: 20px; */\r\n    /* border-radius: 2px!important; */\r\n    position: relative;\r\n    display: inline-block;\r\n    margin: 10px 15px;\r\n    transition: transform .25s ease\r\n}\r\n\r\n.card:hover {\r\n    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .4);\r\n    transform: scale(1.02);\r\n    cursor: pointer;\r\n}\r\n\r\n.cardHeader {\r\n    height: 100px;\r\n    width: 100px;\r\n    background-image: linear-gradient(dimgrey, grey, #a9a9a9);\r\n    border-radius: 10px 10px 0 0;\r\n    text-align: center;\r\n    vertical-align: center\r\n}\r\n\r\n.cardBody {\r\n    padding: 5px;\r\n    background-color: #003658;\r\n    position: absolute;\r\n    color: #fff;\r\n    width: 100px;\r\n    height: fit-content;\r\n    text-align: center;\r\n    font-size: 19px\r\n}\r\n\r\n.cardBody div {\r\n    font-weight: 700\r\n}\r\n\r\n.cardIcon {\r\n    font-size: 90px;\r\n    color: #fff;\r\n    position: relative;\r\n    /* top: 65px */\r\n    height: inherit;\r\n    width: inherit;\r\n}\r\n\r\n.cardFooter {\r\n    background-color: #165788;\r\n    color: #fff;\r\n    margin-top: 15px;\r\n    height: 195px;\r\n    border-radius: 0 0 10px 10px\r\n}\r\n\r\n.cardFooter a {\r\n    color: #fff\r\n}\r\n\r\n.bottom-mid {\r\n    position: absolute;\r\n    bottom: -15px;\r\n    left: 25px;\r\n    color: black;\r\n}\r\n\r\n.suspend {\r\n    height: 100px !important;\r\n    width: 84px !important;\r\n    margin: 5px !important;\r\n}\r\n\r\n.disabledsuspend {\r\n    height: 100px !important;\r\n    width: 84px !important;\r\n    margin: 5px !important;\r\n    color: #C3C3C3;\r\n}\r\n\r\n.suspend:hover {\r\n    box-shadow: 0px 8px 16px 0px;\r\n    transform: scale(1.07);\r\n}\r\n\r\n.suspension-img {\r\n    height: 50px !important;\r\n    width: 50px !important;\r\n}\r\n\r\n.suspensiondd {\r\n    width: 80% !important;\r\n}\r\n\r\n/* :host ::ng-deep .ui-multiselect .ui-multiselect-label{\r\n    height: 25px;\r\n} */\r\n\r\n/* :host ::ng-deep .p-listbox{\r\nbackground-color: #fff !important;\r\n} */\r\n\r\n.category-name {\r\n    font-size: 1.4em;\r\n}\r\n\r\n:host ::ng-deep .p-listbox {\r\n    border: none !important;\r\n    background: transparent !important;\r\n}\r\n\r\n:host ::ng-deep .p-listbox .p-listbox-list .p-listbox-item {\r\n    padding: 0 !important;\r\n    background: none !important;\r\n    border: none !important;\r\n    outline: none !important;\r\n    cursor: pointer !important;\r\n}\r\n.p-listbox-list{\r\n    background-color: transparent;\r\n}\r\n.onsite-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-size: 14px;\r\n    color: #333;\r\n    margin: 0 0 6px 0;\r\n}\r\n\r\n.onsite-services {\r\n    /* background: transparent;\r\n    background-color: transparent; */\r\n    box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);\r\n    border: 1px solid #c3dce2 !important;\r\n    border-radius: 5px;\r\n    background-color: #fff;\r\n    height: 50px;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    margin-bottom: 8px;\r\n}\r\n.onsite-services-NoPermit {\r\n    background-color: #fff;\r\n    height: 100%;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    margin-bottom: 8px;\r\n    border-radius: 5px;\r\n}\r\n.onsite-services-empty {\r\n    box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);\r\n    border: 1px solid #c3dce2 !important;\r\n    border-radius: 2px;\r\n    background-color: #fff;\r\n    min-height: 90px;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.os-ok-icon {\r\n    height: 65px;\r\n    min-width: 65px;\r\n    margin: 11px 8px 15px 8px\r\n}\r\n\r\n.ok-icon {\r\n    color: rgb(255, 255, 255);\r\n    font-size: 24px;\r\n    font-weight: 400;\r\n    line-height: 60px;\r\n    height: 65px;\r\n    background-color: #CCC;\r\n    border-radius: 50%;\r\n}\r\n\r\n.os-name {\r\n    /* margin: 5px 5px 5px 70px; */\r\n    margin:15px 5px 5px 15px;\r\n    text-align: center;\r\n    width: 100%;\r\n    /* padding: 1px; */\r\n    /* width: 100%; */\r\n    /* overflow: hidden; */\r\n    /* margin: 28px 5px 5px 50px;\r\n    padding: 1px;\r\n    width: 100%;\r\n    overflow: hidden; */\r\n}\r\n \r\n:host ::ng-deep .p-listbox-item{\r\n    padding:0px !important\r\n}\r\n\r\n:host ::ng-deep .p-listbox {\r\n    background-color: transparent !important;\r\n    border: none !important;\r\n}\r\n\r\n:host ::ng-deep .p-listbox:not(.p-disabled) .p-listbox-item:not(.p-highlight):not(.p-disabled):hover {\r\n    background: none !important;\r\n}\r\n \r\n:host ::ng-deep .p-listbox-list {\r\n    background-color: transparent !important;\r\n}\r\n\r\n.os-name-empty {\r\n    margin: 5px 5px 5px 5px;\r\n    padding: 5px;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    \r\n}\r\n\r\n.os-name-text {\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    /* text-align: left; */\r\n    color: rgb(66, 137, 193);\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    width: 27vw;\r\n    /* color: #4a4a4a; */\r\n    /* font-size: 20px;\r\n    line-height: 30px; */\r\n    /* color: #fff;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    text-align: left; */\r\n}\r\n.os-name-text:hover {\r\n    background:none;\r\n}\r\n\r\n.os-name-text-empty {\r\n    color: #165788;\r\n    font-size: 15px;\r\n    line-height: 21px;\r\n    overflow: hidden;\r\n    text-align: center;\r\n    margin-left: 5px;\r\n    font-weight: 400;\r\n    /* color: #165788;\r\n    font-size: 15px;\r\n    line-height: 18px;\r\n    overflow: hidden;\r\n    text-align: center;\r\n    margin-left: 5px;\r\n    font-weight: 400; */\r\n    /* color: #4a4a4a;\r\n    font-size: 20px;\r\n    line-height: 30px;\r\n    overflow: hidden;\r\n    text-align: left;\r\n    margin-left: 5px; */\r\n}\r\n\r\n.category-card {\r\n/* padding: 8px;\r\nbackground: transparent; */\r\n    /* padding: 8px; */\r\n    background: #888;\r\n    padding: 23px;\r\n    margin-right: 20px;\r\n    margin-left: 20px;\r\n    margin-top: 10px;\r\n    margin-bottom: 42px;\r\n    height: 120px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n}\r\n.category-card:hover {\r\n    transform: scale(1.02);\r\n}\r\n.clicked {\r\n    /* position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    background-image: url('../../assets/Images/green-tick.svg');\r\n    background-repeat: no-repeat;\r\n    background-size: 10px; */\r\n    -webkit-box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n    -moz-box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n    box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n} \r\n\r\n.category-image {\r\n    /* height: 200px;\r\n    width: 200px; */\r\n    /* width: 100%;\r\n    height: 30vh;\r\n    cursor: pointer; */\r\n    width: 50px;\r\n    height: 50px;\r\n    cursor: pointer;\r\n    /* border-radius: 40px; */\r\n}\r\n\r\n.circle-image {\r\n    width: 75px;\r\n    height: 75px;\r\n    border-radius: 50%;\r\n    margin:auto;\r\n    display: inline-block;\r\n    padding: 13px 12px 15px 12px;\r\n}\r\n\r\n.category-image:hover {\r\n    transform: scale(1.03);\r\n}\r\n.background-body{\r\n    background-color: #f2f2f2;\r\n    padding: 0px !important;\r\n    position: relative !important;\r\n    margin: 0 !important;\r\n}\r\n.clsleft{\r\n    /* background-color: #fff; */\r\n    background-image: url('../../assets/Images/select-category-overlay-bg.png');\r\n    background-repeat: no-repeat;\r\n    background-size: 100%;\r\n    background-position: bottom;\r\n    background-repeat: no-repeat;\r\n    /* opacity: 0.7; */\r\n}\r\n\r\n.clsright{\r\n    background-color: transparent !important;\r\n    border: 0.1px solid #d4d4d457;\r\n\r\n}\r\n.clsright .clsPermitContainer{\r\n    background-color:transparent !important;\r\n}\r\n.CategoryName{\r\n  position: relative;\r\n  top: 28px;\r\n  font-weight: 600;\r\n}\r\n\r\n@media screen and (min-width: 40.063em){\r\n.md:col-6 {\r\n    width: 100% !important;\r\n}\r\n}\r\n\r\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:landscape){\r\n    .p-listbox-item, .p-listbox-list, .p-listbox {\r\n        background-color: #f7f0f0 !important;\r\n    }\r\n    .navbar-form .form-group {\r\n        width: 100% !important;\r\n    }\r\n    #btnMultiplePermit {\r\n        position: relative;\r\n        left: 216px;\r\n    }\r\n    \r\n    .clsLstBox {\r\n        margin-top: 0px;\r\n        /* border-right: 1px solid #C8C8C8 !important; */\r\n        /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); */\r\n        padding-left: 0px !important;\r\n        padding-right: 2px;\r\n        background-color: #f2f2f2;\r\n    }\r\n    \r\n    .categoryList {\r\n        overflow: hidden;\r\n        width: 100%;\r\n        border: none !important;\r\n    }\r\n    \r\n    :host ::ng-deep body .p-listbox {\r\n        padding: 0 !important;\r\n        min-width: 12em !important;\r\n        background: #ffffff !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-listbox .p-listbox-item {\r\n        /* box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px; */\r\n        border: 0px solid rgb(221, 221, 221) !important;\r\n    }\r\n    \r\n   \r\n    \r\n    .categoryImage {\r\n        height: 7vw;\r\n        width: 7vw;\r\n        margin-top: 10px;\r\n        /* border-radius: 50%; */\r\n    }\r\n    \r\n    .categoryCaption {\r\n        margin-left: 15px;\r\n        font-size: 16px;\r\n    }\r\n    \r\n    .clsLstBoxChildRight {\r\n        padding: 10px;\r\n        border-radius: 5px;\r\n        border: 1px solid #CCC;\r\n    }\r\n    \r\n    /* Create three equal columns that floats next to each other */\r\n    \r\n    .column {\r\n        float: left;\r\n        width: 95%;\r\n        padding: 4px;\r\n        min-height: 190px;\r\n        margin: 10px;\r\n        background-color: white;\r\n        /* border-radius: 2px; */\r\n        border: 1px solid #c3dce2;\r\n        /* Should be removed. Only for demonstration */\r\n    }\r\n    \r\n    /* Clear floats after the columns */\r\n    \r\n    .row:after {\r\n        content: \"\";\r\n        display: table;\r\n        clear: both;\r\n    }\r\n    \r\n    .cardIcon {\r\n        font-size: 40px;\r\n        color: rgb(30, 12, 134);\r\n        position: relative;\r\n        top: 7px;\r\n    }\r\n    \r\n    .clsCheck {\r\n        opacity: 1 !important;\r\n    }\r\n    \r\n    .clsPermitContainer {\r\n        width: 100%;\r\n        /* height: 400px; */\r\n        overflow: auto;\r\n        overflow-x: hidden;\r\n        /* border: 1px solid #dddddd; */\r\n        border-radius: 5px;\r\n        /* box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.4); */\r\n        padding: 5px;\r\n        background-color: #fff;\r\n        padding: 15px;\r\n        /* cursor: pointer; */\r\n    }\r\n    \r\n    .card {\r\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);\r\n        transition: 0.3s;\r\n        text-align: center;\r\n    }\r\n    \r\n    .card:hover {\r\n        box-shadow: 0 8px 16px 0 rgba(156, 113, 113, 0.3);\r\n    }\r\n    \r\n    .cardContainer {\r\n        margin-top: 10px;\r\n        padding: 2px;\r\n        text-align: center;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n    \r\n    .clsSeletedPermit {\r\n        width: 98%;\r\n    }\r\n    \r\n    .permitImage {\r\n        height: 65px;\r\n        width: 65px;\r\n        /* border-radius: 50%; */\r\n    }\r\n    \r\n    .clsTick {\r\n        float: left;\r\n        position: relative;\r\n        top: 11px;\r\n        left: -18px;\r\n    }\r\n    \r\n    .clsSelectedPermits {\r\n        margin: 5px;\r\n    }\r\n    \r\n    .clsHeading {\r\n        font-size: 14px !important;\r\n        font-weight: bold;\r\n    }\r\n    \r\n    :host ::ng-deep .p-toast .p-toast-message {\r\n        border: 1px solid #165788 !important;\r\n        border-radius: 3px;\r\n        background: #f4f4f4 !important;\r\n        -moz-box-shadow: 3px 3px 12px #165788;\r\n        -webkit-box-shadow: 3px 3px 12px #165788;\r\n        box-shadow: 3px 3px 12px #165788;\r\n    }\r\n    \r\n    :host ::ng-deep .ui-inputtext {\r\n        width: 100% !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-toast .p-toast-message-content {\r\n        padding: 0px !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-toast .p-toast-close-icon {\r\n        color: #ffffff !important;\r\n        /* margin-top: 10px; */\r\n    }\r\n    \r\n    .toast-header {\r\n        background-color: #165788;\r\n        color: #FFF;\r\n        padding: 1px 1px 1px 10px !important;\r\n    }\r\n    \r\n    :host ::ng-deep .ui-multiselect {\r\n        min-width: 38% !important;\r\n        max-width: 38% !important;\r\n    }\r\n    \r\n    .divRow {\r\n        padding-top: 10px;\r\n        padding-bottom: 10px;\r\n    }\r\n    \r\n    .divLabel {\r\n        padding: 5px;\r\n        /* text-align: right; */\r\n    }\r\n    \r\n    :host ::ng-deep body .ui-inputtext {\r\n        border: 0px solid #a6a6a6 !important;\r\n    }\r\n    \r\n    .card {\r\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);\r\n        transition: .3s;\r\n        /* width: 100px; */\r\n        /* top: 20px; */\r\n        /* border-radius: 2px!important; */\r\n        position: relative;\r\n        display: inline-block;\r\n        margin: 10px 15px;\r\n        transition: transform .25s ease\r\n    }\r\n    \r\n    .card:hover {\r\n        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .4);\r\n        transform: scale(1.02);\r\n        cursor: pointer;\r\n    }\r\n    \r\n    .cardHeader {\r\n        height: 100px;\r\n        width: 100px;\r\n        background-image: linear-gradient(dimgrey, grey, #a9a9a9);\r\n        border-radius: 10px 10px 0 0;\r\n        text-align: center;\r\n        vertical-align: center\r\n    }\r\n    \r\n    .cardBody {\r\n        padding: 5px;\r\n        background-color: #003658;\r\n        position: absolute;\r\n        color: #fff;\r\n        width: 100px;\r\n        height: fit-content;\r\n        text-align: center;\r\n        font-size: 19px\r\n    }\r\n    \r\n    .cardBody div {\r\n        font-weight: 700\r\n    }\r\n    \r\n    .cardIcon {\r\n        font-size: 90px;\r\n        color: #fff;\r\n        position: relative;\r\n        /* top: 65px */\r\n        height: inherit;\r\n        width: inherit;\r\n    }\r\n    \r\n    .cardFooter {\r\n        background-color: #165788;\r\n        color: #fff;\r\n        margin-top: 15px;\r\n        height: 195px;\r\n        border-radius: 0 0 10px 10px\r\n    }\r\n    \r\n    .cardFooter a {\r\n        color: #fff\r\n    }\r\n    \r\n    .bottom-mid {\r\n        position: absolute;\r\n        bottom: -15px;\r\n        left: 25px;\r\n        color: black;\r\n    }\r\n    \r\n    .suspend {\r\n        height: 100px !important;\r\n        width: 84px !important;\r\n        margin: 5px !important;\r\n    }\r\n    \r\n    .disabledsuspend {\r\n        height: 100px !important;\r\n        width: 84px !important;\r\n        margin: 5px !important;\r\n        color: #C3C3C3;\r\n    }\r\n    \r\n    .suspend:hover {\r\n        box-shadow: 0px 8px 16px 0px;\r\n        transform: scale(1.07);\r\n    }\r\n    \r\n    .suspension-img {\r\n        height: 50px !important;\r\n        width: 50px !important;\r\n    }\r\n    \r\n    .suspensiondd {\r\n        width: 80% !important;\r\n    }\r\n    \r\n    /* :host ::ng-deep .ui-multiselect .ui-multiselect-label{\r\n        height: 25px;\r\n    } */\r\n    \r\n    /* :host ::ng-deep .p-listbox{\r\n    background-color: #fff !important;\r\n    } */\r\n    \r\n    .category-name {\r\n        font-size: 1.4em;\r\n    }\r\n    \r\n    :host ::ng-deep .p-listbox {\r\n        border: none !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-listbox .p-listbox-list .p-listbox-item {\r\n        padding: 0 !important;\r\n    }\r\n    \r\n    .onsite-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        font-size: 14px;\r\n        color: #333;\r\n        margin: 0 0 6px 0;\r\n    }\r\n    \r\n    .onsite-services {\r\n   \r\n        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);\r\n        border: 1px solid #c3dce2 !important;\r\n        border-radius: 5px;\r\n        background-color: #fff;\r\n        min-height: 50px;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        margin-bottom: 8px;\r\n    }\r\n    \r\n    .onsite-services-NoPermit {\r\n        background-color: #fff;\r\n        height: 100%;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        margin-bottom: 8px;\r\n    }\r\n    .onsite-services-empty {\r\n        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);\r\n        border: 1px solid #c3dce2 !important;\r\n        border-radius: 2px;\r\n        background-color: #fff;\r\n        min-height: 90px;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        margin-bottom: 8px;\r\n    }\r\n    \r\n    .os-ok-icon {\r\n        height: 65px;\r\n        min-width: 65px;\r\n        margin: 11px 8px 15px 8px\r\n    }\r\n    \r\n    .ok-icon {\r\n        color: rgb(255, 255, 255);\r\n        font-size: 24px;\r\n        font-weight: 400;\r\n        line-height: 60px;\r\n        height: 65px;\r\n        background-color: #CCC;\r\n        border-radius: 50%;\r\n    }\r\n    \r\n    .os-name {\r\n        margin: 12px 14px 5px 12px;\r\n        padding: 5px;\r\n        width: 100%;\r\n        overflow: hidden;\r\n        text-align: center;\r\n        /* margin: 28px 5px 5px 50px;\r\n        padding: 1px;\r\n        width: 100%;\r\n        overflow: hidden; */\r\n    }\r\n    \r\n    .os-name-empty {\r\n        margin: 8px 5px 5px 5px;\r\n        padding: 1px;\r\n        width: 100%;\r\n        overflow: hidden;\r\n    }\r\n    \r\n    .os-name-text {\r\n        color: rgb(66, 137, 193);\r\n        font-size: 15px;\r\n        line-height: 15px;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        /* text-align: left; */\r\n        font-weight: 600;\r\n        /* color: #4a4a4a;\r\n        font-size: 20px;\r\n        line-height: 30px;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        text-align: left; */\r\n    }\r\n    \r\n    .os-name-text-empty {\r\n        color: #165788;\r\n    font-size: 12px;\r\n    line-height: 17px;\r\n    overflow: hidden;\r\n    text-align: center;\r\n        /* color: #4a4a4a;\r\n        font-size: 20px;\r\n        line-height: 30px;\r\n        overflow: hidden;\r\n        text-align: left;\r\n        margin-left: 5px; */\r\n    }\r\n    \r\n    .category-card {\r\n        padding: 8px;\r\n        background: transparent;\r\n        cursor: pointer;\r\n    }\r\n    .category-card:hover {\r\n        transform: scale(1.02);\r\n    }\r\n    .clicked {\r\n        /* position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        background-image: url('../../assets/Images/green-tick.svg');\r\n        background-repeat: no-repeat;\r\n        background-size: 10px; */\r\n        -webkit-box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n        -moz-box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n        box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n    }    \r\n\r\n    .circle-image {\r\n        width: 62px;\r\n        height: 62px;\r\n        border-radius: 50%;\r\n        margin: auto;\r\n        display: inline-block;\r\n        padding: 12px 10px;\r\n        position: relative;\r\n        top: 17px;\r\n    }\r\n    \r\n    .category-image {\r\n        height: 40px;\r\n        width: 40px;\r\n        cursor: pointer;\r\n        top:0px;   \r\n        position: relative;\r\n              /* border-radius: 30px; */\r\n        /* top: 24px; */\r\n        /* height: 100%;\r\n        width: 100%;\r\n        cursor: pointer; */\r\n    }\r\n    \r\n    .category-image:hover {\r\n        transform: scale(1.03);\r\n    }\r\n    .background-body{\r\n        background-color: #f2f2f2;\r\n        padding: 0px !important;\r\n        position: relative !important;\r\n        margin: 0 !important;\r\n    }\r\n    .CategoryName{\r\n        position: relative;\r\n        top: 58px;\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n      }\r\n}\r\n\r\n\r\n@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation:portrait){\r\n    .p-listbox-item, .p-listbox-list, .p-listbox {\r\n        background-color: #f7f0f0 !important;\r\n    }\r\n    .CategoryName{\r\n        position: relative;\r\n        top: 58px;\r\n        font-size: 10px;\r\n        width: 100px;\r\n        left: -42px;\r\n        font-weight: 600;\r\n      }\r\n    /* Override start */\r\n    .navbar .navbar-header {\r\n        margin-left: 10%!important;\r\n        /* margin-right: 0!important; */\r\n    }\r\n    .app-name {\r\n        color: white;\r\n        margin-left: 8px;\r\n        /* font-size: 28px; */\r\n        /* font-weight: bold; */\r\n        vertical-align: -8px;\r\n        text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);\r\n        font-family: Segoe UI;\r\n        font-weight: 100;\r\n    }\r\n    /* Override end */\r\n    #btnMultiplePermit {\r\n        position: relative;\r\n        left: 216px;\r\n    }\r\n    \r\n    .clsLstBox {\r\n        margin-top: 0px;\r\n        /* border-right: 1px solid #C8C8C8 !important; */\r\n        /* box-shadow: 0 0 2px rgba(0, 0, 0, 0.2); */\r\n        padding-left: 0px !important;\r\n        padding-right: 2px;\r\n        background-color: #f2f2f2;\r\n    }\r\n    \r\n    .categoryList {\r\n        overflow: hidden;\r\n        width: 100%;\r\n        border: none !important;\r\n    }\r\n    \r\n    :host ::ng-deep body .p-listbox {\r\n        padding: 0 !important;\r\n        min-width: 12em !important;\r\n        background: #ffffff !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-listbox .p-listbox-item {\r\n        /* box-shadow: rgba(0, 0, 0, 0.4) 5px 5px 10px; */\r\n        border: 0px solid rgb(221, 221, 221) !important;\r\n    }\r\n    \r\n  \r\n    \r\n    .categoryImage {\r\n        height: 7vw;\r\n        width: 7vw;\r\n        margin-top: 10px;\r\n        /* border-radius: 50%; */\r\n    }\r\n    \r\n    .categoryCaption {\r\n        margin-left: 15px;\r\n        font-size: 16px;\r\n    }\r\n    \r\n    .clsLstBoxChildRight {\r\n        padding: 10px;\r\n        border-radius: 5px;\r\n        border: 1px solid #CCC;\r\n    }\r\n    \r\n    /* Create three equal columns that floats next to each other */\r\n    \r\n    .column {\r\n        float: left;\r\n        width: 95%;\r\n        padding: 4px;\r\n        min-height: 190px;\r\n        margin: 10px;\r\n        background-color: white;\r\n        /* border-radius: 2px; */\r\n        border: 1px solid #c3dce2;\r\n        /* Should be removed. Only for demonstration */\r\n    }\r\n    \r\n    /* Clear floats after the columns */\r\n    \r\n    .row:after {\r\n        content: \"\";\r\n        display: table;\r\n        clear: both;\r\n    }\r\n    \r\n    .cardIcon {\r\n        font-size: 40px;\r\n        color: rgb(30, 12, 134);\r\n        position: relative;\r\n        top: 7px;\r\n    }\r\n    \r\n    .clsCheck {\r\n        opacity: 1 !important;\r\n    }\r\n    \r\n    .clsPermitContainer {\r\n        width: 100%;\r\n        /* height: 400px; */\r\n        overflow: auto;\r\n        overflow-x: hidden;\r\n        /* border: 1px solid #dddddd; */\r\n        border-radius: 5px;\r\n        /* box-shadow: 5px 5px 10px rgb(0, 0, 0, 0.4); */\r\n        padding: 5px;\r\n        background-color: #fff;\r\n        padding: 15px;\r\n        /* cursor: pointer; */\r\n    }\r\n    \r\n    .card {\r\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);\r\n        transition: 0.3s;\r\n        text-align: center;\r\n    }\r\n    \r\n    .card:hover {\r\n        box-shadow: 0 8px 16px 0 rgba(156, 113, 113, 0.3);\r\n    }\r\n    \r\n    .cardContainer {\r\n        margin-top: 10px;\r\n        padding: 2px;\r\n        text-align: center;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n    \r\n    .clsSeletedPermit {\r\n        width: 98%;\r\n    }\r\n    \r\n    .permitImage {\r\n        height: 65px;\r\n        width: 65px;\r\n        /* border-radius: 50%; */\r\n    }\r\n    \r\n    .clsTick {\r\n        float: left;\r\n        position: relative;\r\n        top: 11px;\r\n        left: -18px;\r\n    }\r\n    \r\n    .clsSelectedPermits {\r\n        margin: 5px;\r\n    }\r\n    \r\n    .clsHeading {\r\n        font-size: 14px !important;\r\n        font-weight: bold;\r\n    }\r\n    \r\n    :host ::ng-deep .p-toast .p-toast-message {\r\n        border: 1px solid #165788 !important;\r\n        border-radius: 3px;\r\n        background: #f4f4f4 !important;\r\n        -moz-box-shadow: 3px 3px 12px #165788;\r\n        -webkit-box-shadow: 3px 3px 12px #165788;\r\n        box-shadow: 3px 3px 12px #165788;\r\n    }\r\n    \r\n    :host ::ng-deep .ui-inputtext {\r\n        width: 100% !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-toast .p-toast-message-content {\r\n        padding: 0px !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-toast .p-toast-close-icon {\r\n        color: #ffffff !important;\r\n        /* margin-top: 10px; */\r\n    }\r\n    \r\n    .toast-header {\r\n        background-color: #165788;\r\n        color: #FFF;\r\n        padding: 1px 1px 1px 10px !important;\r\n    }\r\n    \r\n    :host ::ng-deep .ui-multiselect {\r\n        min-width: 38% !important;\r\n        max-width: 38% !important;\r\n    }\r\n    \r\n    .divRow {\r\n        padding-top: 10px;\r\n        padding-bottom: 10px;\r\n    }\r\n    \r\n    .divLabel {\r\n        padding: 5px;\r\n        /* text-align: right; */\r\n    }\r\n    \r\n    :host ::ng-deep body .ui-inputtext {\r\n        border: 0px solid #a6a6a6 !important;\r\n    }\r\n    \r\n    .card {\r\n        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .2);\r\n        transition: .3s;\r\n        /* width: 100px; */\r\n        /* top: 20px; */\r\n        /* border-radius: 2px!important; */\r\n        position: relative;\r\n        display: inline-block;\r\n        margin: 10px 15px;\r\n        transition: transform .25s ease\r\n    }\r\n    \r\n    .card:hover {\r\n        box-shadow: 0 4px 12px 0 rgba(0, 0, 0, .4);\r\n        transform: scale(1.02);\r\n        cursor: pointer;\r\n    }\r\n    \r\n    .cardHeader {\r\n        height: 100px;\r\n        width: 100px;\r\n        background-image: linear-gradient(dimgrey, grey, #a9a9a9);\r\n        border-radius: 10px 10px 0 0;\r\n        text-align: center;\r\n        vertical-align: center\r\n    }\r\n    \r\n    .cardBody {\r\n        padding: 5px;\r\n        background-color: #003658;\r\n        position: absolute;\r\n        color: #fff;\r\n        width: 100px;\r\n        height: fit-content;\r\n        text-align: center;\r\n        font-size: 19px\r\n    }\r\n    \r\n    .cardBody div {\r\n        font-weight: 700\r\n    }\r\n    \r\n    .cardIcon {\r\n        font-size: 90px;\r\n        color: #fff;\r\n        position: relative;\r\n        /* top: 65px */\r\n        height: inherit;\r\n        width: inherit;\r\n    }\r\n    \r\n    .cardFooter {\r\n        background-color: #165788;\r\n        color: #fff;\r\n        margin-top: 15px;\r\n        height: 195px;\r\n        border-radius: 0 0 10px 10px\r\n    }\r\n    \r\n    .cardFooter a {\r\n        color: #fff\r\n    }\r\n    \r\n    .bottom-mid {\r\n        position: absolute;\r\n        bottom: -15px;\r\n        left: 25px;\r\n        color: black;\r\n    }\r\n    \r\n    .suspend {\r\n        height: 100px !important;\r\n        width: 84px !important;\r\n        margin: 5px !important;\r\n    }\r\n    \r\n    .disabledsuspend {\r\n        height: 100px !important;\r\n        width: 84px !important;\r\n        margin: 5px !important;\r\n        color: #C3C3C3;\r\n    }\r\n    \r\n    .suspend:hover {\r\n        box-shadow: 0px 8px 16px 0px;\r\n        transform: scale(1.07);\r\n    }\r\n    \r\n    .suspension-img {\r\n        height: 50px !important;\r\n        width: 50px !important;\r\n    }\r\n    \r\n    .suspensiondd {\r\n        width: 80% !important;\r\n    }\r\n    \r\n    /* :host ::ng-deep .ui-multiselect .ui-multiselect-label{\r\n        height: 25px;\r\n    } */\r\n    \r\n    /* :host ::ng-deep .p-listbox{\r\n    background-color: #fff !important;\r\n    } */\r\n    \r\n    .category-name {\r\n        font-size: 1.4em;\r\n    }\r\n    \r\n    :host ::ng-deep .p-listbox {\r\n        border: none !important;\r\n    }\r\n    \r\n    :host ::ng-deep .p-listbox .p-listbox-list .p-listbox-item {\r\n        padding: 0 !important;\r\n    }\r\n    \r\n    .onsite-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        font-size: 14px;\r\n        color: #333;\r\n        margin: 0 0 6px 0;\r\n    }\r\n    \r\n    .onsite-services {\r\n        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);\r\n        border: 1px solid #c3dce2 !important;\r\n        border-radius: 5px;\r\n        background-color: #fff;\r\n        min-height: 40px;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        margin-bottom: 8px;\r\n    }\r\n    .onsite-services-NoPermit {\r\n        background-color: #fff;\r\n        height: 100%;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        margin-bottom: 8px;\r\n    }\r\n    .onsite-services-empty {\r\n        box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, .11);\r\n        border: 1px solid #c3dce2 !important;\r\n        border-radius: 2px;\r\n        background-color: #fff;\r\n        min-height: 90px;\r\n        box-sizing: border-box;\r\n        display: flex;\r\n        margin-bottom: 8px;\r\n    }\r\n    \r\n    .os-ok-icon {\r\n        height: 65px;\r\n        min-width: 65px;\r\n        margin: 11px 8px 15px 8px\r\n    }\r\n    \r\n    .ok-icon {\r\n        color: rgb(255, 255, 255);\r\n        font-size: 24px;\r\n        font-weight: 400;\r\n        line-height: 60px;\r\n        height: 65px;\r\n        background-color: #CCC;\r\n        border-radius: 50%;\r\n    }\r\n    \r\n    .os-name {\r\n        /* margin: 28px 5px 5px 6px; */\r\n      margin:15px 5px 5px 15px;\r\n      padding: 5px;\r\n      width: 100%;\r\n      overflow: hidden;\r\n      text-align: center;\r\n    }\r\n    \r\n    .os-name-empty {\r\n        margin: 14px 5px 5px 5px;\r\n        padding: 1px;\r\n        width: 100%;\r\n        overflow: hidden;\r\n    }\r\n    \r\n    .os-name-text {\r\n        color: black;\r\n        font-size: 11px;\r\n        line-height: 13px;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        /* text-align: left; */\r\n        font-weight: 600;\r\n        /* color: #4a4a4a;\r\n        font-size: 20px;\r\n        line-height: 30px;\r\n        white-space: nowrap;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        text-align: left; */\r\n    }\r\n    \r\n    .os-name-text-empty {\r\n        color: #165788;\r\n        font-size: 12px;\r\n        line-height: 17px;\r\n        overflow: hidden;\r\n        text-align: left;\r\n        /* color: #4a4a4a;\r\n        font-size: 20px;\r\n        line-height: 30px;\r\n        overflow: hidden;\r\n        text-align: left;\r\n        margin-left: 5px; */\r\n    }\r\n    \r\n    .category-card {\r\n        padding-top: 4px;\r\n        padding: -52px;\r\n        margin-right: 20px;\r\n        margin-left: 20px;\r\n        margin-top: 10px;\r\n        margin-bottom: 42px;\r\n        height: 120px;\r\n        border-radius: 5px;\r\n        padding-left: 39px;\r\n        padding-right: 50px;\r\n        padding-bottom: 7px;\r\n        cursor: pointer;\r\n        /* padding: 8px;\r\n        background: transparent; */\r\n    }\r\n    .category-card:hover {\r\n        transform: scale(1.02);\r\n    }\r\n    .clicked {\r\n        /* position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        background-image: url('../../assets/Images/green-tick.svg');\r\n        background-repeat: no-repeat;\r\n        background-size: 10px; */\r\n        -webkit-box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n        -moz-box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n        box-shadow: 10px 10px 20px -5px rgba(0,5,8,1);\r\n    } \r\n\r\n    .circle-image {\r\n        width: 62px;\r\n        height: 62px;\r\n        border-radius: 50%;\r\n        margin: auto;\r\n        display: inline-block;\r\n        padding: 12px 10px;\r\n        position: relative;\r\n        left: -24px;\r\n        top: 17px;\r\n    }\r\n    \r\n    .category-image {\r\n        height: 37px;\r\n        width: 37px;\r\n        cursor: pointer;\r\n        position: relative;\r\n        top: 0px;\r\n        left: 1px;\r\n        /* height: 50px;\r\n        width: 50px;\r\n        cursor: pointer;\r\n        position: relative;\r\n        top: 19px; */\r\n        /* height: 100%;\r\n        width: 100%;\r\n        cursor: pointer; */\r\n    }\r\n    \r\n    .category-image:hover {\r\n        transform: scale(1.1);\r\n    }\r\n    .background-body{\r\n        background-color: #f2f2f2;\r\n        padding: 0px !important;\r\n        position: relative !important;\r\n        margin: 0 !important;\r\n    }    \r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
